import { createAction, props } from '@ngrx/store';
import { MainToolbarHeaderInfo } from '../se-toolbar/se-header-toolbar/se-header-info/se-header-info.component';
import {
    BaseSRMessage,
    KeyImage,
    PacsTuple,
    USMeasureMessage,
    USMeasureReport,
    USStressEchoInitMessage,
    USStressEchoSelectMessage,
    XmlRequestType,
} from '../services/imaging/common';
import { AssociationType, EcgNotification } from '../services/signalr-notifications.models';
import { ExtensaAuthState } from '../connectivity/types';

export const seChangeTheme = createAction('[Se] ChangeTheme', props<{ theme: 'dark' | 'light' }>());

export const seEcgAlarm = createAction('[Se] EcgAlarm', props<{ alarm: EcgNotification; correlationId: string }>());

export const seEcgAlarmWarning = createAction(
    '[Se] EcgAlarmWarning',
    props<{ alarm: EcgNotification; correlationId: string }>(),
);

export const seExaminationAssociation = createAction(
    '[Se] ExaminationAssociation',
    props<{ idExamination: string; associationType: AssociationType }>(),
);

export const seExtensaAuth = createAction('[Se] ExtensaAuth', props<ExtensaAuthState | null>());

export const seExtensaConnected = createAction('[Se] ExtensaConnected', props<{ isConnected: boolean }>());

export const seHeaderClick = createAction('[Se] HeaderClick');

export const seIsIntegrationAppConnected = createAction(
    '[Se] IsIntegrationConnected',
    props<{ isConnected: boolean }>(),
);

export const seLogin = createAction('[Se] Login', props<{ sso?: 'WEB' | 'WPF' }>());

export const seLogoClick = createAction('[Se] LogoClick');

export const seNotificationError = createAction('[Se] NotificationError', props<{ message: string }>());

export const seNotificationSuccess = createAction('[Se] NotificationSuccess', props<{ message: string }>());

export const seNotificationWarning = createAction('[Se] NotificationWarning', props<{ message: string }>());

export const seShowClientInfo = createAction('[Se] ShowClientInfo');

export const seShowHelp = createAction('[Se] ShowHelp');

export const seShowViewerInfo = createAction('[Se] ShowViewerInfo');

export const seSignalrConnected = createAction('[Se] SignalrConnected', props<{ isConnected: boolean }>());

export const seViewerConnected = createAction('[Se] ViewerConnected', props<{ isConnected: boolean }>());

export const seSetToolbarInfo = createAction(
    '[Se] SetToolbarInfo',
    props<{ info1?: MainToolbarHeaderInfo; info2?: MainToolbarHeaderInfo }>(),
);

export const seUserLogout = createAction('[Se] UserLogout', props<{ forced?: boolean }>());

export const seViewerKeyImageAdd = createAction('[Se] ViewerKeyImageAdd', props<{ image: KeyImage }>());

export const seViewerKeyImagesDelete = createAction('[Se] ViewerKeyImageDelete', props<{ images: KeyImage[] }>());

export const seViewerKeyImageRefresh = createAction('[Se] ViewerKeyImageRefresh', props<{ image: KeyImage }>());

export const seViewerKeyImagesSet = createAction('[Se] ViewerKeyImagesSet', props<{ images: KeyImage[] }>());

export const seViewerKeyImagesPerRows = createAction('[Se] ViewerKeyImagesPerRows', props<{ rows: number }>());

export const seViewerUSMeasureDeleteRequest = createAction(
    '[Se] ViewerUSMeasureDeleteRequest',
    props<{
        measure: USMeasureMessage;
        callback: string;
        requestId: string;
    }>(),
);

export const seViewerUSMeasureDeleteResponse = createAction(
    '[Se] ViewerUSMeasureDeleteResponse',
    props<{
        result: boolean;
        callback: string;
        requestId: string;
    }>(),
);

export const seViewerUSMeasureGetReportRequest = createAction(
    '[Se] ViewerUSMeasureGetReportRequest',
    props<{
        nPla: PacsTuple;
        callback: string;
        requestId: string;
    }>(),
);

export const seViewerUSMeasureGetReportResponse = createAction(
    '[Se] ViewerUSMeasureGetReportResponse',
    props<{
        report: USMeasureReport;
        callback: string;
        requestId: string;
    }>(),
);

export const seViewerUSMeasureImportRequest = createAction('[Se] ViewerUSMeasureImport', props<USMeasureMessage>());

export const seViewerUSStressEchoInit = createAction('[Se] ViewerUSStressEchoInit', props<USStressEchoInitMessage>());

export const seViewerUSStressEchoSelect = createAction(
    '[Se] ViewerUSStressEchoSelect',
    props<USStressEchoSelectMessage>(),
);

export const seViewerSRAdd = createAction('[Se] ViewerSRAdd', props<BaseSRMessage>());

export const seViewerSRDelete = createAction('[Se] ViewerSRDelete', props<BaseSRMessage>());

export const seViewerUSMeasureImportRequestThirdParts = createAction(
    '[Se] ViewerXmlImport',
    props<{ requestType: XmlRequestType; xml: string }>(),
);

export const seViewerUSKineticMeasureImportRequest = createAction(
    '[Se] ViewerKineticXmlImport',
    props<{ requestType: XmlRequestType; xml: string }>(),
);

export const seLockedExams = createAction('[Se] LockedExams', props<{ examsToClose: string[] }>());

/** US2AI actions */
export const seUS2AIAlert = createAction(
    '[Se] seUS2AIAlert',
    props<{ idRepository: string; studyInstanceUid: string }>(),
);
/** --------- */
